import React from 'react'
import { Settings } from '../components/Settings'
import { useQuery } from '../hooks/useQuery'

export function Submitted() {
  const query = useQuery()
  const fileName = query.get('fileName')
  return (
    <>
      <Settings className="mb-10" />

      <div className="text-center tracking-tight text-gray-500">
        <h2 className="text-lg text-gray-500">Survey submitted!</h2>
        {!!fileName ? (
          <div className="text-sm mt-6">
            <div className="font-light">
              Your response also saved to your Pod as
            </div>
            <div>
              <span className="bg-gray-200">{fileName}</span>
            </div>
          </div>
        ) : null}
      </div>
    </>
  )
}
